module.exports = __webpack_public_path__ + "img/doubleSideTriangleVertical.a7156400.svg";